import React, { useState } from "react";
import { useFormik } from "formik";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import compInfos from "./set-password-form.json";
import { useLangContext } from "../../context/langContext";
import { object, string } from "yup";
import { PasswordCreateRequest } from "../../services/Endpoints/account";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import MuiTextField from "../../components/common/text-field/MuiTextField";
import { useProfileContext } from "../../context/profileContext";
import { useWorkspaceContext } from "../../context/workspaceContext";

export default function SetPasswordForm() {
  const [waiting, setWaiting] = useState(false);
  const { setPasswordSet } = useProfileContext();
  const { setWorkSpaceModal, workspace } = useWorkspaceContext();
  const { lang } = useLangContext();
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const infos = compInfos[lang];
  const mobileError = infos.inputs[0].errors;
  const passwordError = infos.inputs[1].errors;
  const loginSchema = object({
    password: string().min(8, mobileError.min).required(mobileError.required),
    confirm_password: string()
      .min(8, passwordError.min)
      .required(passwordError.required),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setWaiting(true);
      const passwordCreateRequest = new PasswordCreateRequest(
        protectedInstance
      );
      try {
        const { confirm_password, password } = values;
        const resp = await passwordCreateRequest.send({
          confirm_password,
          password,
        });
        setPasswordSet(false);
        if (!workspace) {
          setWorkSpaceModal(true);
        }
        setWaiting(false);
      } catch (error: any) {
        errorResolver({ error, setNotification });
        setWaiting(false);
      }
    },
    enableReinitialize: true,
  });

  return (
    <Stack
      maxWidth="100%"
      width="97%"
      gap="20.31px"
      mx="10px"
      component="form"
      onSubmit={formik.handleSubmit}
    >
      <MuiTextField
        width="100%"
        name="password"
        type="password"
        placeholder={infos.inputs[0].placeholder}
        label={infos.inputs[0].label}
        value={formik.values.password}
        handleChange={formik.handleChange}
        Example={infos.inputs[0].Example}
        error={
          formik.touched.password &&
          Boolean(formik.errors.password) &&
          formik.errors.password
        }
      />

      <MuiTextField
        width="100%"
        name="confirm_password"
        type="password"
        placeholder={infos.inputs[1].placeholder}
        label={infos.inputs[1].label}
        value={formik.values.confirm_password}
        handleChange={formik.handleChange}
        Example={infos.inputs[1].Example}
        error={
          formik.touched.confirm_password &&
          Boolean(formik.errors.confirm_password) &&
          formik.errors.confirm_password
        }
      />
      <LoadingButton
        variant="confirm"
        sx={{
          mt: "10px",
        }}
        type="submit"
        loading={waiting}
      >
        {infos.buttonText}
      </LoadingButton>
    </Stack>
  );
}
//
